import icon_dashboard from "./assets/icons/white_dashboard.svg";
import icon_sale from "./assets/icons/white_sale.svg";
import icon_sale2 from "./assets/icons/white_sale2.svg";
import icon_shopping_bag from "./assets/icons/white_shopping_bag.svg";
import icon_customer from "./assets/icons/white_customer.svg";
import icon_commision from "./assets/icons/white_commision.svg";
import icon_delivery from "./assets/icons/white_delivery.svg";
import icon_inventory from "./assets/icons/white_inventory.svg";
import icon_purchase from "./assets/icons/white_purchase.svg";
import icon_supplychain from "./assets/icons/white_supplychain.svg";
import icon_project from "./assets/icons/white_project.svg";
import icon_expense from "./assets/icons/white_expense.svg";
import icon_vendor from "./assets/icons/white_vendor.svg";
import icon_cash from "./assets/icons/white_cash.svg";
import icon_tax from "./assets/icons/white_tax.svg";
import icon_employee from "./assets/icons/white_employee.svg";
import icon_profit_lost from "./assets/icons/white_profit_lost.svg";
import icon_report from "./assets/icons/white_report.svg";
import icon_setting from "./assets/icons/white_setting.svg";
import icon_permision from "./assets/icons/white_permision.svg";
import icon_account from "./assets/icons/white_account.svg";
import icon_table from "./assets/icons/white_table.svg";
import icon_ticket from "./assets/icons/white_ticket.svg";
import icon_general_ledger from "./assets/icons/white_general_ledger.svg";
import icon_payroll from "./assets/icons/white_payroll.svg";
import icon_safe_stock from "./assets/icons/white_safe_stock.svg";

import color_sale from "./assets/icons/color_sale.svg";
import color_cart from "./assets/icons/color_cart.svg";
import color_inventory from "./assets/icons/color_inventory.svg";
import color_good from "./assets/icons/color_good.svg";
import color_good2 from "./assets/icons/color_good2.svg";
import color_food from "./assets/icons/color_food.svg";
import color_food2 from "./assets/icons/color_food2.svg";
import color_serve from "./assets/icons/color_serve.svg";
import color_customer from "./assets/icons/color_customer.svg";
import color_beverage from "./assets/icons/color_beverage.svg";
import color_beverage2 from "./assets/icons/color_beverage2.svg";
import color_expandable_service from "./assets/icons/color_expandable_service.svg";

export default {
  icon_dashboard: icon_dashboard,
  icon_sale: icon_sale,
  icon_sale2: icon_sale2,
  icon_shopping_bag: icon_shopping_bag,
  icon_customer: icon_customer,
  icon_commision: icon_commision,
  icon_delivery: icon_delivery,
  icon_inventory: icon_inventory,
  icon_purchase: icon_purchase,
  icon_supplychain: icon_supplychain,
  icon_project: icon_project,
  icon_expense: icon_expense,
  icon_vendor: icon_vendor,
  icon_cash: icon_cash,
  icon_tax: icon_tax,
  icon_employee: icon_employee,
  icon_profit_lost: icon_profit_lost,
  icon_report: icon_report,
  icon_setting: icon_setting,
  icon_permision: icon_permision,
  icon_account: icon_account,
  icon_table: icon_table,
  icon_ticket: icon_ticket,
  icon_general_ledger: icon_general_ledger,
  icon_payroll: icon_payroll,
  icon_safe_stock: icon_safe_stock,
  color_sale: color_sale,
  color_cart: color_cart,
  color_inventory: color_inventory,
  color_good: color_good,
  color_good2: color_good2,
  color_food: color_food,
  color_food2: color_food2,
  color_serve: color_serve,
  color_beverage: color_beverage,
  color_beverage2: color_beverage2,
  color_expandable_service: color_expandable_service,
  color_customer: color_customer,
};
